module.exports = __webpack_public_path__ + "media/images/client/send_message_icon-84aae8865e6d79d8ab29208706e53ea5.png";